
import axiosInstance from "../utils/api";

import endpoints
    from "../constants/endpoints";


const ReportAndAnalyticsAPI = {

    fetchAnalytics: async (startDate, endDate) => {
        try {
            const response = await axiosInstance.get(
                `${endpoints.adminReportAndAnalytics}`,
                { startDate, endDate },
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            );
            return response.data; // Expecting array of user objects
        } catch (error) {
            throw new Error('Failed to fetch users: ' + error.message);
        }
    },

    fetchDashboardReportsAndAnalytics : async ()=>{
        try {
            const response = await axiosInstance.get(
                `${endpoints.adminDashboardReportAndAnalytics}`,
                
            );
            return response.data; 
        } catch (error) {
            throw new Error('Failed to fetch users: ' + error.message);
        }
    }

}



export default ReportAndAnalyticsAPI;